import ApplicationController from './application_controller';
import Rails from "@rails/ujs"

export default class extends ApplicationController {

  static targets = ['selectCheckBoxes', 'checkBox']

  selectAllCheckboxes(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
    this.checkBoxTargets.forEach((checkbox) => { checkbox.checked = !checkbox.checked; });
  }


}
